document.addEventListener('turbo:load', () => {
  const inputs = document.querySelectorAll('#deposits-list input[type=checkbox]');

  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];

    input.addEventListener('change', (event) => {
      const totalElement = document.querySelector('#deposit-total')
      const feeElement = document.querySelector('#deposit-fee')
      const totalWithFeeElement = document.querySelector('#deposit-total-with-fee')

      const total = parseFloat(totalElement.innerHTML.replace(/[^0-9.-]+/g,""))
      const fee = parseFloat(feeElement.innerHTML.replace(/[^0-9.-]+/g,""))

      let valueChange = Number(event.target.getAttribute('data-value'))
      let feeChange = Number(event.target.getAttribute('data-fee'))

      if (!event.target.checked) {
        valueChange = -valueChange
        feeChange = -feeChange
      }

      const format = (n) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

      totalElement.innerHTML = format(total + valueChange)
      feeElement.innerHTML = format(fee + feeChange)
      totalWithFeeElement.innerHTML = format(total + valueChange + fee + feeChange)
    });
  }
})
